import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { PatientActions } from 'src/redux/actions/constant';

import patientService from 'src/services/apiServices/patientService';

const {
  FAILURE_CREATE_PATIENT,
  SUCCESS_CREATE_PATIENT,
  REQUEST_CREATE_PATIENT,
  LOADING_CREATE_PATIENT,
  GET_ALL_PATIENT_PRIOR_CHARGES_REQUEST
} = PatientActions;

function* createPatients(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_CREATE_PATIENT });
    const response = yield call(patientService.createPatient, action.payload);
    if (response?.status === 201) {
      yield put({ type: SUCCESS_CREATE_PATIENT, payload: response.data });
      yield put({ type: GET_ALL_PATIENT_PRIOR_CHARGES_REQUEST, patientUuid: response.data?.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_CREATE_PATIENT, payload: error });
  }
}

function* createPatientsSaga() {
  yield takeEvery(REQUEST_CREATE_PATIENT, createPatients);
}

export default createPatientsSaga;
